export const APP_NAME = 'Supplier Risk Solutions';
export const PERSIST_STORE_NAME = 'srs';
export const REDIRECT_URL_KEY = 'redirectUrl';
